interface StoredRequest {
	requestId: string,
	topic: string,
	tripId: string,
	message: string,
}
export function saveUniqueObjectToLocalStorage(
	key: string,
	newItem: StoredRequest
  ): void {
	const existingRaw = localStorage.getItem(key);
	let existing: StoredRequest[] = [];
  
	if (existingRaw) {
	  try {
		existing = JSON.parse(existingRaw) as StoredRequest[];
	  } catch (err) {
		console.error('Failed to parse existing localStorage data', err);
	  }
	}
  
	const exists = existing.some(item => item.requestId === newItem.requestId);
  
	if (!exists) {
	  existing.push(newItem);
	  localStorage.setItem(key, JSON.stringify(existing));
	} 
  }

export function getStoredRequests(key: string): StoredRequest[] {
	const raw = localStorage.getItem(key);
	if (!raw) return [];
  
	try {
	  return JSON.parse(raw) as StoredRequest[];
	} catch (err) {
	  console.error('Error parsing stored requests', err);
	  return [];
	}
  }

export function removeObjectFromLocalStorageById(
	key: string,
	requestId: string
  ): void {
	const existingRaw = localStorage.getItem(key);
	if (!existingRaw) return;
  
	try {
	  const existing: StoredRequest[] = JSON.parse(existingRaw);
	  const filtered = existing.filter(item => item.requestId !== requestId);
  
	  localStorage.setItem(key, JSON.stringify(filtered));
	} catch (err) {
	  console.error('Failed to remove item from localStorage', err);
	}
  }